import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    categoriesList : [],
    selectedCategory:{},
}
const categoriesSlice = createSlice({
    name:'categories',
    initialState,
    reducers:{
        setCategoriesList:(state,{payload})=>{
            state.categoriesList = payload
        },
        setSelectedCategory:(state,{payload})=>{
            state.selectedCategory = payload
        },
    }
})

export const { setCategoriesList,setSelectedCategory} = categoriesSlice.actions
export default categoriesSlice.reducer